@if (isStandaloneLayout()) {
  <div class="relative">
    @if (unreadNotificationsCount() > 0) {
      <div
        class="typography-labels-small-emphasis absolute -right-1 top-0 z-50 grid aspect-square h-5 place-items-center rounded-full bg-text-common-signal text-white"
      >
        {{ unreadNotificationsCount() }}
      </div>
    }

    <p-button
      size="small"
      pTooltip="Notifications"
      tooltipPosition="left"
      (click)="onStandaloneButtonClick($event)"
    >
      <ng-template #icon>
        <svg-icon src="assets/icons/general/social-bell.svg" />
      </ng-template>
    </p-button>
  </div>
}

@if (isMenuLayout()) {
  <p-button
    variant="text"
    severity="contrast"
    styleClass="w-full !justify-start"
    (click)="notificationPopover.toggle($event)"
  >
    <svg-icon src="assets/icons/general/social-bell.svg" />
    <span>Notifications</span>
    <div
      class="typography-labels-medium-emphasis ml-auto grid h-6 place-items-center rounded-full bg-interface-primary-100 px-1 text-interface-primary-color"
    >
      {{ unreadNotificationsCount() }}
    </div>
  </p-button>
}

<p-popover
  #notificationPopover
  styleClass="[&_.p-popover-content]:!p-2"
  appendTo="body"
  (onShow)="onNotificationPopoverShow()"
  (onHide)="onNotificationPopoverHide()"
>
  <div
    class="flex max-h-[300px] min-w-[20rem] flex-col"
    [ngClass]="isMenuLayout() ? 'max-w-[23rem]' : 'max-w-[26rem]'"
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
    (touchstart)="$event.stopPropagation()"
  >
    <div class="flex items-center pl-1">
      <span class="typography-headings-small text-text-common-contrast">
        {{ notificationsTitle() }}
      </span>
      <div class="ml-auto flex items-center">
        <div class="relative">
          @if (showFilterIndicator()) {
            <div
              class="absolute right-0 top-0 z-50 block aspect-square w-2 rounded-full bg-interface-primary-color"
            ></div>
          }
          <p-button
            size="small"
            severity="contrast"
            variant="text"
            pTooltip="Filter"
            tooltipPosition="left"
            (click)="onFilterButtonClick($event)"
          >
            <ng-template #icon>
              <svg-icon src="assets/icons/general/action-filter.svg" />
            </ng-template>
          </p-button>
        </div>

        <p-button
          size="small"
          variant="text"
          severity="contrast"
          pTooltip="Bulk actions"
          tooltipPosition="left"
          (click)="onBulkActionsButtonClick($event)"
          [disabled]="
            selectedFilter()?.value === NotificationAlertFilterValue.Archived
          "
        >
          <ng-template #icon>
            <svg-icon src="assets/icons/general/kebab.svg" />
          </ng-template>
        </p-button>

        <p-button
          size="small"
          variant="text"
          severity="contrast"
          pTooltip="Settings"
          tooltipPosition="left"
          (click)="openSettings()"
        >
          <svg-icon src="assets/icons/general/settings.svg" />
        </p-button>
      </div>
    </div>

    @if (isLoading()) {
      <ng-container *ngTemplateOutlet="notificationsLoadingTemplate" />
    } @else if (notificationsCount() === 0) {
      <ng-container *ngTemplateOutlet="notificationsEmpty" />
    } @else {
      <ng-container *ngTemplateOutlet="notificationsTemplate" />
    }

    <span class="typography-body-default mt-auto p-2 text-text-common-base">
      {{ notificationsCount() }} of {{ filteredNotificationsCount() }}
      <ng-container [ngPlural]="filteredNotificationsCount()">
        <ng-template ngPluralCase="=1"> notification </ng-template>
        <ng-template ngPluralCase="other"> notifications </ng-template>
      </ng-container>
    </span>
  </div>
</p-popover>

<p-drawer
  styleClass="!w-[30rem]"
  [visible]="drawerVisible()"
  (visibleChange)="drawerVisible.set($event)"
  position="right"
  maskStyle="opacity: 0"
>
  <ng-template #header>
    <div class="flex w-full items-center">
      <h1 class="typography-headings-small whitespace-nowrap p-1">
        {{ notificationsTitle() }}
      </h1>

      <div class="ml-auto flex items-center gap-1">
        <div class="relative">
          @if (showFilterIndicator()) {
            <div
              class="absolute right-0 top-0 z-50 block aspect-square w-2 rounded-full bg-interface-primary-color"
            ></div>
          }
          <p-button
            size="small"
            severity="contrast"
            variant="text"
            pTooltip="Filter"
            tooltipPosition="left"
            (click)="onFilterButtonClick($event)"
          >
            <ng-template #icon>
              <svg-icon src="assets/icons/general/action-filter.svg" />
            </ng-template>
          </p-button>
        </div>
        <p-button
          size="small"
          variant="text"
          severity="contrast"
          pTooltip="Bulk actions"
          tooltipPosition="left"
          (click)="onBulkActionsButtonClick($event)"
          [disabled]="
            selectedFilter()?.value === NotificationAlertFilterValue.Archived
          "
        >
          <ng-template #icon>
            <svg-icon src="assets/icons/general/kebab.svg" />
          </ng-template>
        </p-button>

        <p-button
          size="small"
          severity="contrast"
          variant="text"
          pTooltip="Settings"
          tooltipPosition="left"
          (click)="openSettings()"
        >
          <ng-template #icon>
            <svg-icon src="assets/icons/general/settings.svg" />
          </ng-template>
        </p-button>
      </div>
    </div>
  </ng-template>

  @if (isLoading()) {
    <ng-container *ngTemplateOutlet="notificationsLoadingTemplate" />
  } @else if (notificationsCount() === 0) {
    <ng-container *ngTemplateOutlet="notificationsEmpty" />
  } @else {
    <div class="flex h-full flex-col">
      <div
        class="h-[calc(100vh-9rem)] overflow-y-auto"
        (scroll)="onScroll($event)"
      >
        <ng-container *ngTemplateOutlet="notificationsTemplate" />
      </div>

      <span class="typography-body-default mt-auto text-text-common-base">
        {{ notificationsCount() }} of {{ filteredNotificationsCount() }}
        <ng-container [ngPlural]="filteredNotificationsCount()">
          <ng-template ngPluralCase="=1"> notification </ng-template>
          <ng-template ngPluralCase="other"> notifications </ng-template>
        </ng-container>
      </span>
    </div>
  }
</p-drawer>

<p-popover
  #notificationFilterPopover
  appendTo="body"
  styleClass="[&_.p-popover-content]:!p-0"
  (onShow)="onNotificationFilterPopoverShow()"
  (onHide)="onNotificationFilterPopoverHide()"
>
  <ng-template #content>
    <div
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
      (touchstart)="$event.stopPropagation()"
    >
      <p-listbox
        class="w-[14rem]"
        optionLabel="label"
        highlightOnSelect="false"
        [options]="filterOptions"
        [ngModel]="selectedFilter()"
        (ngModelChange)="onFilterSelectionChange($event)"
      >
        <ng-template let-item pTemplate="item">
          <div class="flex w-full items-center gap-2">
            <svg-icon
              [src]="item.iconUrl"
              class="shrink-0 text-text-common-primary"
            />
            <span class="typography-body-default text-text-common-contrast">
              {{ item.label }}
            </span>
            @if (selectedFilter()?.value === item.value) {
              <svg-icon
                src="assets/icons/general/check.svg"
                class="ml-auto shrink-0 text-text-common-primary"
              />
            }
          </div>
        </ng-template>
      </p-listbox>
    </div>
  </ng-template>
</p-popover>

<p-popover
  #notificationBulkActionsPopover
  appendTo="body"
  styleClass="[&_.p-popover-content]:!p-0"
  (onShow)="onNotificationBulkActionsPopoverShow()"
  (onHide)="onNotificationBulkActionsPopoverHide()"
>
  <ng-template #content>
    <div
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
      (touchstart)="$event.stopPropagation()"
    >
      <p-listbox
        class="w-[14rem]"
        optionLabel="label"
        highlightOnSelect="false"
        [options]="bulkActionOptions"
        [ngModel]="selectedBulkAction()"
        (ngModelChange)="onBulkActionSelectionChange($event)"
      >
        <ng-template let-item pTemplate="item">
          <div class="flex w-full items-center gap-2">
            <svg-icon
              [src]="item.iconUrl"
              class="shrink-0 text-text-common-primary"
            />

            <span class="typography-body-default text-text-common-contrast">
              {{ item.label }}
            </span>

            @if (selectedBulkAction()?.value === item.value) {
              <svg-icon
                src="assets/icons/general/check.svg"
                class="ml-auto shrink-0 text-text-common-primary"
              />
            }
          </div>
        </ng-template>
      </p-listbox>
    </div>
  </ng-template>
</p-popover>

<ng-template #notificationsEmpty>
  <div class="grid h-full w-full place-items-center px-2 py-5">
    <div class="flex flex-col items-center gap-2.5">
      <svg-icon src="assets/icons/general/social-bell.svg" />
      <h3 class="typography-headings-x-small text-text-common-contrast">
        You're all caught up
      </h3>
      <span class="typography-body-default text-text-common-base">
        Any notifications you've opted into will appear here.
      </span>
    </div>
  </div>
</ng-template>

<ng-template #notificationsLoadingTemplate>
  <div
    class="grid h-full w-full place-items-center gap-2 rounded-xl bg-white p-5"
  >
    <ag1-loader />
  </div>
</ng-template>

<ng-template #notificationsTemplate>
  <div class="flex flex-col overflow-y-auto pr-1" (scroll)="onScroll($event)">
    <!-- Today -->
    @if (notificationsToday()?.length > 0) {
      <div class="flex flex-col">
        <span class="typography-overlines-small text-text-common-base">
          TODAY
        </span>
        <div class="flex flex-col">
          @for (notification of notificationsToday(); track notification.id) {
            <ng-container
              *ngTemplateOutlet="
                notificationItemTemplate;
                context: { notification: notification }
              "
            />
          }
        </div>
      </div>
    }

    <!-- Yesterday -->
    @if (notificationsYesterday()?.length > 0) {
      <div class="flex flex-col">
        <span class="typography-overlines-small text-text-common-base">
          YESTERDAY
        </span>
        <div class="flex flex-col">
          @for (
            notification of notificationsYesterday();
            track notification.id
          ) {
            <ng-container
              *ngTemplateOutlet="
                notificationItemTemplate;
                context: { notification: notification }
              "
            />
          }
        </div>
      </div>
    }

    <!-- Older -->
    @if (notificationsOlder()?.length > 0) {
      <div class="flex flex-col">
        <span class="typography-overlines-small text-text-common-base">
          OLDER
        </span>
        <div class="flex flex-col">
          @for (notification of notificationsOlder(); track notification.id) {
            <ng-container
              *ngTemplateOutlet="
                notificationItemTemplate;
                context: { notification: notification }
              "
            />
          }
        </div>
      </div>
    }

    @if (loadingMore()) {
      <div class="flex items-center justify-center py-3">
        <ag1-loader />
      </div>
    }
  </div>
</ng-template>

<ng-template #notificationItemTemplate let-notification="notification">
  <div
    class="group grid cursor-pointer grid-cols-[auto_1fr] items-center gap-2.5 rounded-lg px-2 py-3.5 hover:bg-interface-common-hover"
    (click)="onNotificationClick(notification)"
  >
    <div
      class="border-common-brand w-fit rounded-xl border bg-interface-primary-50 p-2 text-text-common-primary"
    >
      <svg-icon [src]="getNotificationIcon(notification)" />
    </div>

    <div class="relative flex flex-col gap-2">
      @if (!isMenuLayout()) {
        <div
          class="absolute right-0 top-0 z-10 hidden cursor-pointer rounded-xl bg-interface-surface-0 p-1.5 group-hover:block"
          (click)="$event.stopPropagation()"
        >
          @if (!notification?.readAt) {
            <p-button
              size="small"
              variant="text"
              severity="contrast"
              pTooltip="Mark as read"
              tooltipPosition="left"
              (click)="onToggleNotificationMarkAsRead(notification)"
            >
              <svg-icon
                src="assets/icons/general/system-feedback-success.svg"
              />
            </p-button>
          } @else {
            <p-button
              size="small"
              variant="text"
              severity="contrast"
              pTooltip="Mark as unread"
              tooltipPosition="left"
              (click)="onToggleNotificationMarkAsRead(notification)"
            >
              <svg-icon src="assets/icons/general/communication-unread.svg" />
            </p-button>
          }

          <p-button
            size="small"
            variant="text"
            severity="contrast"
            pTooltip="Archive"
            tooltipPosition="left"
            [disabled]="!!notification?.archivedAt"
            (click)="onArchiveNotification(notification)"
          >
            <svg-icon src="assets/icons/general/action-archive.svg" />
          </p-button>
        </div>
      }

      <div class="grid grid-cols-[1fr_auto] items-start gap-1">
        <span
          class="typography-headings-x-small line-clamp-2 select-none text-text-common-contrast"
        >
          {{ notification?.title }}
        </span>

        <div class="ml-auto flex items-center gap-1.5">
          <ag1-time-since
            class="shrink-0 whitespace-nowrap"
            prefix=""
            [timestamp]="notification?.deliveredAt"
          />

          @if (!notification?.readAt) {
            <div
              class="relative mr-1.5 aspect-square w-2 rounded-full bg-text-informative-default"
            ></div>
          }
        </div>
      </div>

      <p
        class="typography-body-small line-clamp-2 select-none text-text-common-contrast"
      >
        {{ notification?.body }}
      </p>
    </div>
  </div>
</ng-template>
